export enum FolderType {
    COMPANY = "company",
    PARTICULAR = "particular",
}
